export const funktionen = [
    {
        id: "fuehrungskraft",
        label: "Führungskraft",
        size: [30, 8],
        render: (svg) => svg.path("M0,0 h30 v8 h-30 Z").attr("fill", "black"),
    },
    {
        id: "sonderfunktion",
        label: "Sonderfunktion (Fachberater)",
        size: [30, 8],
        render: (svg) => svg.path("M0,8 h30"),
    },
];
